import React from 'react';
import { connectRefinementList } from 'react-instantsearch-dom';

import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
import ProductListingClearAllFiltersButton from '../ProductListingClearAllFiltersButton';
import ProductListingQuickshipFilter from '../ProductListingQuickshipFilter';
import DesktopProductListingListFilter from './DesktopProductListingListFilter';
import DesktopProductListingSearchFilter from './DesktopProductListingSearchFilter';
import ProductListingWidthRangeFilter from '../ProductListingWidthRangeFilter';

const DesktopProductListingSidebarFiltersUI = ({ variant }) => {
  const { filters = [] } = useProductListingPageContext();

  // Remove color filter because on desktop we render it in the header instead
  const filtersWithoutColors = filters.filter(filter => filter.id !== 'color');

  return (
    <div className="pb-4">
      {/* Vertical padding for the Clear All button is handled within the
          ProductListingClearAllFiltersButton component so that the padding
          shows and hides at the same time as the button */}
      <ProductListingClearAllFiltersButton />

      <div className="flex flex-col gap-5">
        {filtersWithoutColors.map(({ id, label, options }) => {
          if (id === 'search') {
            return <DesktopProductListingSearchFilter key={id} />;
          }

          if (id === 'quickship') {
            return <ProductListingQuickshipFilter key={id} />;
          }

          if (id === 'widthRange') {
            return <ProductListingWidthRangeFilter key={id} showTitle />;
          }

          if (variant === 'advanced-search' && options.length === 0) {
            // In advanced search, if there are no options from Algolia for this filter,
            // then don't render the filter at all
            return null;
          }

          return (
            <div key={id}>
              <h3 className="text-base font-bold mb-2">{label}</h3>
              <DesktopProductListingListFilter id={id} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

const AlgoliaProductFiltersDesktop = connectRefinementList(
  DesktopProductListingSidebarFiltersUI
);

AlgoliaProductFiltersDesktop.displayName = 'AlgoliaProductFiltersDesktop';

const DesktopProductListingSidebarFilters = ({ variant }) =>
  variant === 'advanced-search' ? (
    // Use Algolia-connected version of the filters for advanced search

    <AlgoliaProductFiltersDesktop
      attribute="type"
      facetOrdering
      limit={500}
      variant={variant}
    />
  ) : (
    <DesktopProductListingSidebarFiltersUI />
  );

export default DesktopProductListingSidebarFilters;
